import {
  GRID_VIDEO_ASPECT_RATIO,
  GRID_VIDEO_MARGIN,
} from "constants/constants";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  GRID_VIEW,
  PINNED_CAMERA,
  PINNED_SHARE,
  selectBigVideoWidth,
} from "slices/spaceMediaSlice";

const useAdjustStyle = (elem, luid, order, visual, share) => {
  const bigVidWidth = useSelector(selectBigVideoWidth);
  const expanded = useRef(null);

  useEffect(() => {
    if (!elem) {
      window.efs_debug && window.log("mediacontainer not found: " + luid);
      return;
    }
    window.efs_debug && window.log("useAdjustStyle" + JSON.stringify(elem));
    window.efs_debug && window.log(visual);
    window.efs_debug && window.log(bigVidWidth);
    if (visual === PINNED_SHARE && share === "board") {
      elem.style.width = 98 + "%";
      elem.style.margin = GRID_VIDEO_MARGIN + "px";
      elem.style.height = 98 + "%";
      if (!elem.classList.contains("expanded")) {
        elem.classList.add("expanded");
        if (!expanded.current)
          expanded.current = (Date.now() % 100000000) + parseInt(luid);
        elem.style.order = expanded.current;
      }
    } else if (
      visual === GRID_VIEW ||
      visual === PINNED_SHARE ||
      visual === PINNED_CAMERA
    ) {
      elem.style.width = bigVidWidth + "px";
      elem.style.margin = GRID_VIDEO_MARGIN + "px";
      elem.style.height = bigVidWidth * GRID_VIDEO_ASPECT_RATIO + "px";
      if (!elem.classList.contains("expanded")) {
        elem.classList.add("expanded");
        if (!expanded.current)
          expanded.current = (Date.now() % 100000000) + parseInt(luid);
        elem.style.order = expanded.current;
      }
    } else {
      elem.style.width = null;
      elem.style.margin = null;
      elem.style.height = null;
      if (elem.classList.contains("expanded")) {
        elem.classList.remove("expanded");
      }
      expanded.current = null;
      elem.style.order = order;
    }
  }, [elem, order, luid, visual, share, bigVidWidth]);

  useEffect(() => {
    elem.classList.add("activated");
    return () => {
      if (elem) elem.classList.remove("activated");
    };
  }, [elem, luid]);
};

export default useAdjustStyle;
